/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyResponseModel } from '../../models/client-survey-response-model';
import { CreateSurveyResponseRequest } from '../../models/create-survey-response-request';

export interface CreateSurveyResponse$Json$Params {
  
    /**
     * properties of new surveyresponse
     */
    body?: CreateSurveyResponseRequest
}

export function createSurveyResponse$Json(http: HttpClient, rootUrl: string, params?: CreateSurveyResponse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyResponse$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyResponseModel>;
    })
  );
}

createSurveyResponse$Json.PATH = '/api/SurveyResponse';
